﻿import { Controller } from "@hotwired/stimulus";

function createInputElement(name, value) {
    var input = document.createElement("input");

    input.setAttribute("type", "hidden");
    input.setAttribute("id", name);
    input.setAttribute("name", name);
    input.setAttribute("value", value);

    return input;
}

export default class extends Controller {
    static get values() {
        return {
            message: String,
            title: String,
            icon: String,
            iconColor: String,
            confirmLabel: String,
            cancelLabel: String
        };
    }

    connect() {
        var tagName = this.element.tagName;
        if (tagName === "A") {
            this.element.addEventListener("click", e => this.handleLinkConfirmation(e));
        }
        else if (tagName === "BUTTON") {
            this.element.addEventListener("click", e => this.handleButtonConfirmation(e));
        }
    }

    buildOptions(callback) {
        var options = {
            message: this.messageValue,
            callback: callback
        };

        var title = "";
        if (this.hasIconValue && this.iconValue) {
            var iconClass = "material-symbols-outlined confirm-icon";
            if (this.hasIconColorValue && this.iconColorValue) {
                iconClass += ` text-${this.iconColorValue}`;
            }
            title += `<span class="${iconClass}" aria-hidden="true">${this.iconValue}</span> `;
        }
        if (this.hasTitleValue && this.titleValue) {
            title += this.titleValue;
        }
        if (title) {
            options.title = title;
        }

        if (this.confirmLabelValue || this.cancelLabelValue) {
            options.buttons = {};
            if (this.confirmLabelValue) {
                options.buttons.confirm = { label: this.confirmLabelValue };
            }
            if (this.cancelLabelValue) {
                options.buttons.cancel = { label: this.cancelLabelValue };
            }
        }

        return options;
    }

    handleLinkConfirmation(e) {
        e.preventDefault();
        bootbox.confirm(this.buildOptions(function (confirmed) {
            if (confirmed) {
                window.location.href = e.target.href;
            }
        }));
    }

    handleButtonConfirmation(e) {
        e.preventDefault();

        bootbox.confirm(this.buildOptions(function (confirmed) {
            if (confirmed) {
                var element = e.target;

                var form = element.closest("form");
                var name = element.getAttribute("name");
                
                if (name) {
                    var value = element.getAttribute("value");
                    if (value) {
                        var existing = form.querySelector(`input[name="${name}"]`);
                        if (!existing) {
                            var input = createInputElement(name, value);
                            form.append(input);
                        }
                        else {
                            existing.value = value;
                        }
                    }
                }

                form.submit();
            }
        }));
    }
}
